module.exports = __webpack_public_path__ + "static/img/IMG_20160309_204639.d0aa30cb.jpg";